<template>
    <div class="only-chart">
        <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
                <li>
                    <a>{{ $t('vendas') }}</a>
                </li>
                <li>
                    <router-link :to="'/ven/cockpit'">{{ $t('cockpit') }}</router-link>
                </li>
                <li>
                    <a href="#" aria-current="page">{{ this.$t(this.$route.params.tipo) }}</a>
                </li>
            </ul>
        </nav>
        <div
            v-for="(d, i) in dataset"
            :key="i"
            class="chart"
            ref="chartItem"
            :data-title="d.titulo"
            :data-item-id="i"
        >
            <BigNumber
                :ref="`${d.tipo}-${d.titulo}`"
                v-if="d && d.tipo == 'bignumber'"
                :title="$t(d.titulo)"
                :datacontent="d"
            />
            <ZoomBarChart
                :ref="`${d.tipo}-${d.titulo}`"
                v-if="d && d.tipo == 'bar'"
                :title="$t(d.titulo)"
                :datacontent="d"
                :direction="d.direction"
            />
            <DonutChart
                :ref="`${d.tipo}-${d.titulo}`"
                v-if="d && d.tipo == 'donut'"
                :title="$t(d.titulo)"
                :datacontent="d"
            />
        </div>
    </div>
</template>
<script>
import DonutChart from '@/components/shared/chart/DonutChart';
import BigNumber from '@/components/shared/chart/BigNumber';
import ZoomBarChart from '@/components/shared/chart/ZoomBarChart';
import CockpitVendasService from '@/services/CockpitVendasService';

export default {
    data() {
        return {
            dataset: [],
            charts: [],
            breadCrumbs: [
                { name: 'ven-cockpit', title: this.$t('cockpit'), active: true },
                {
                    name: 'ven-cockpit-chart',
                    params: { tipo: this.$route.params.tipo },
                    title: this.$t(this.$route.params.tipo),
                    active: false,
                },
            ],
        };
    },
    components: {
        DonutChart,
        ZoomBarChart,
        BigNumber,
    },
    created() {
        this.service = new CockpitVendasService(this.$http, this.$router);

        let body = document.getElementsByTagName('body')[0];

        body.onresize = this.debounce(this.resize, 150);

        if (this.$route.params.tipo) {
            this.carregarDados(this.$route.params.tipo.replace('chart-', ''));
        }
    },
    methods: {
        resize() {
            this.redrawCharts();
        },
        redrawCharts() {
            this.$d3.selectAll('.chart-tooltip').remove();

            this.dataset.forEach((c) => {
                this.$refs[`${c.tipo}-${c.titulo}`][0].redrawChart();
            });
        },
        carregarDados(tipo) {
            this.service.getChart(tipo).then((res) => {
                if (res) {
                    this.dataset.push(res);
                } else {
                    this.$router.push({ name: 'ven-cockpit' });
                }
            });
        },
    },
};
</script>

<style lang="scss">
.only-chart {
    .chart {
        padding: 0 15px;
        position: relative;
    }
    .chart-content {
        height: 70vh !important;
        &.speedometer {
            text-align: center;
            height: 750vh !important;
            margin-top: 50px;
            margin-bottom: 30px;
        }
        &.big-number-content {
            height: 35vh !important;
            .big-number-wrapper {
                margin-top: 25vh;
                .big-number-value {
                    font-size: 600% !important;
                }
            }
        }
        &.long-text-content {
            height: 750vh !important;
            min-height: 80px;
            max-height: 300px;
        }
    }
    nav.breadcrumb {
        padding: 15px;
        margin: 0 !important;
        font-size: 12px;
    }
}
</style>
